import React from 'react';
import NotificationDemo from '../components/UI/NotificationDemo';
import AxiosDebug from '../components/Debug/AxiosDebug';

const NotificationDemoPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Sistema de Notificações
          </h1>
          <p className="text-lg text-gray-600">
            Demonstração do sistema de notificações com Snackbar
          </p>
        </div>

        <div className="space-y-8">
          {/* Debug Axios */}
          <AxiosDebug />

          {/* Demonstração Principal */}
          <NotificationDemo />

          {/* Informações sobre o Sistema */}
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Como Funciona
            </h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-medium text-gray-900 mb-2">Características:</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Notificações automáticas em ações</li>
                  <li>• Auto-fechamento configurável</li>
                  <li>• Animações suaves de entrada/saída</li>
                  <li>• Tipos: Sucesso, Erro, Aviso, Info</li>
                  <li>• Posicionamento fixo no canto superior</li>
                  <li>• Múltiplas notificações simultâneas</li>
                </ul>
              </div>

              <div>
                <h4 className="font-medium text-gray-900 mb-2">Implementação:</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Context API para gerenciamento global</li>
                  <li>• Hook personalizado para facilitar uso</li>
                  <li>• Componente Snackbar reutilizável</li>
                  <li>• Integração com todas as páginas</li>
                  <li>• Mensagens pré-definidas e customizáveis</li>
                  <li>• Suporte a TypeScript</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Exemplos de Uso */}
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Exemplos de Uso
            </h3>
            
            <div className="space-y-4">
              <div className="border-l-4 border-green-500 pl-4">
                <h4 className="font-medium text-gray-900">Sucesso:</h4>
                <p className="text-sm text-gray-600">
                  Login realizado, post criado, mensagem enviada
                </p>
              </div>

              <div className="border-l-4 border-red-500 pl-4">
                <h4 className="font-medium text-gray-900">Erro:</h4>
                <p className="text-sm text-gray-600">
                  Falha no login, erro de validação, problema de conexão
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 pl-4">
                <h4 className="font-medium text-gray-900">Aviso:</h4>
                <p className="text-sm text-gray-600">
                  Campos obrigatórios, dados incompletos, sessão expirada
                </p>
              </div>

              <div className="border-l-4 border-blue-500 pl-4">
                <h4 className="font-medium text-gray-900">Informação:</h4>
                <p className="text-sm text-gray-600">
                  Status de carregamento, dados processados, atualizações
                </p>
              </div>
            </div>
          </div>

          {/* Código de Exemplo */}
          <div className="bg-gray-900 rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-semibold text-white mb-4">
              Exemplo de Código
            </h3>
            
            <pre className="text-sm text-gray-300 overflow-x-auto">
              <code>{`// Hook personalizado
const notifications = useNotifications();

// Notificações pré-definidas
notifications.success.login();
notifications.error.network();
notifications.warning.validation('Mensagem');
notifications.info.loading('Carregando...');

// Notificações customizadas
notifications.showSuccess('Título', 'Mensagem');
notifications.showError('Erro', 'Descrição do erro');`}</code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationDemoPage;
